export var DefinitionType;
(function (DefinitionType) {
    DefinitionType["Flow"] = "flow";
    DefinitionType["Blueprint"] = "blueprint";
    DefinitionType["Action"] = "action";
    DefinitionType["Trigger"] = "trigger";
    DefinitionType["Connection"] = "connection";
    DefinitionType["Type"] = "type";
})(DefinitionType || (DefinitionType = {}));
export var AlertLevel;
(function (AlertLevel) {
    AlertLevel["INFO"] = "INFO";
    AlertLevel["WARNING"] = "WARNING";
})(AlertLevel || (AlertLevel = {}));
//# sourceMappingURL=domino-types.js.map